var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"autoplay":"","loop":"","muted":"","playsinline":"","poster":_vm.poster || null,"aria-label":_vm.ariaLabel || null},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":"video/mp4"}})])}
var staticRenderFns = []

export { render, staticRenderFns }